import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { AppBar, Toolbar } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import Chip from "@material-ui/core/Chip";
import clsx from "clsx";

import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import DashboardIcon from "../../../../../Assets/Logo/DashboardIcon.svg";
import NoticeIcon from "../../../../../Assets/Logo/NoticeIcon.svg";
import TimetableIcon from "../../../../../Assets/Logo/TimetableIcon.svg";
import StudentRoleIcon from "../../../../../Assets/Logo/StudentRoleIcon.svg";
import TeacherRoleIcon from "../../../../../Assets/Logo/TeacherRoleIcon.svg";
import ParentRoleIcon from "../../../../../Assets/Logo/ParentRoleIcon.svg";

import { useStyles } from "./UserBar.css";
import MobileDrawer from "../MobileDrawer/MobileDrawer";
import {
  getUserRefreshToken,
  userLogout,
} from "../../../../../Redux/Actions/actions";
import CustomDialogBox from "../../../../CustomDialogBox/CustomDialogBox";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import BottomMenu from "./BottomMenu/BottomMenu";
import Axios from "axios";
import { url } from "../../../../../Config/Config";
import Skeleton from "@material-ui/lab/Skeleton";

class UserBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false,
      mobileOpen: false,
      bottomMenu: [
        {
          name: "Home",
          url: "/dashboard",
          status: false,
          icon: (
            <img
              src={DashboardIcon}
              alt="Dashboard"
              style={{ width: 20, height: 20 }}
            />
          ),
        },
        {
          name: "Notices",
          url: "/notices",
          status: false,
          icon: (
            <img
              src={NoticeIcon}
              alt="Notices"
              style={{ width: 20, height: 20 }}
            />
          ),
        },
        {
          name: "Classes",
          url: "/timetable",
          status: false,
          icon: (
            <img
              src={TimetableIcon}
              alt="Timetable"
              style={{ width: 20, height: 20 }}
            />
          ),
        },
        {
          name: "Profile",
          url: "/profile",
          status: false,
          icon: (
            <img
              src={StudentRoleIcon}
              alt="Profile"
              style={{ width: 20, height: 20 }}
            />
          ),
        },
        {
          name: "More",
          status: false,
          icon: <MenuIcon style={{ width: 20, height: 20 }} />,
        },
      ],
      schoolDetails: {},
      isEmtpy: false,
      userName: "",
    };
  }

  componentDidMount() {
    this.handleActiveMenu(this.props);
    this.getSchoolInfo();
    this.getUserDetails();
  }

  getSchoolInfo = async () => {
    const response = await Axios.get(`${url}/api/setting`);
    if (response.data._id) {
      this.setState({ schoolDetails: response.data, isEmpty: false });
    } else {
      this.setState({ schoolDetails: {}, isEmpty: true });
    }
  };

  getUserDetails = async () => {
    try {
      let userName = "";
      if (this.props.role === "Teacher") {
        const response = await Axios.get(
          `${url}/api/staffs/teacher/${this.props.userId}`,
          {
            headers: { Authorization: `Bearer ${this.props.userToken}` },
          }
        );
        userName = response.data.teacher.fullName;
      } else {
        const responseStudent = await Axios.get(
          `${url}/api/students/${this.props.userId}`,
          {
            headers: { Authorization: `Bearer ${this.props.userToken}` },
          }
        );
        userName =
          responseStudent.data.student.firstName +
          " " +
          responseStudent.data.student.lastName;
      }
      this.setState({ userName });
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.userRefreshToken };
        this.props.getUserRefreshToken(refreshToken, this.props.role);
        this.getUserDetails();
      }
    }
  };

  handleActiveMenu = (data) => {
    let newArray;
    newArray = this.state.bottomMenu.map((filter) =>
      filter.url === data.match.url.toString()
        ? { ...filter, status: true }
        : { ...filter, status: false }
    );
    this.setState({
      bottomMenu: newArray,
    });
  };

  handleToggleDrawer = () => {
    this.setState({
      mobileOpen: !this.state.mobileOpen,
    });
  };

  handleDialogOpen = () => {
    this.setState({
      dialogOpen: true,
    });
  };

  handleDialogClose = () => {
    this.setState({
      dialogOpen: false,
    });
  };

  handleLogout = async () => {
    this.props.userLogout();
    this.handleDialogClose();
  };

  render() {
    const { classes, open } = this.props;
    const { schoolDetails } = this.state;

    let roleIcon =
      this.props.role === "Student"
        ? StudentRoleIcon
        : this.props.role === "Teacher"
        ? TeacherRoleIcon
        : this.props.role === "Parent" && ParentRoleIcon;
    return (
      <div>
        <div className={classes.sectionDesktop}>
          <AppBar
            position="fixed"
            elevation={0}
            className={clsx(classes.appBar, {
              [classes.appBarShift]: open,
            })}
          >
            <Toolbar
              className={classes.toolbar}
              style={{ paddingLeft: open === false && 0 }}
            >
              <IconButton
                disableRipple
                onClick={this.props.handleDrawerOpen}
                edge="start"
                className={clsx(classes.drawerMenuButton, {
                  [classes.hide]: open,
                })}
              >
                <MenuIcon style={{ width: 25, height: 25 }} />
              </IconButton>
              <div
                style={{ flexGrow: 1, color: "#181818", fontWeight: "bold" }}
              >
                {schoolDetails._id ? (
                  <div>
                    {schoolDetails.schoolName} ({schoolDetails.shortName})
                  </div>
                ) : this.state.isEmpty ? (
                  <div>{this.props.role} Portal</div>
                ) : (
                  <Skeleton variant="rect" style={{ width: 50 }} />
                )}
              </div>

              <div style={{ color: "#181818", marginRight: 10 }}>
                <b>Role: </b>
                <Chip
                  icon={
                    <img
                      src={roleIcon}
                      alt={this.props.role}
                      style={{ width: 20, height: 20 }}
                    />
                  }
                  label={<b style={{ color: "#eee" }}>{this.props.role}</b>}
                  style={{ backgroundColor: "#8e8e8e" }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Tooltip
                  arrow
                  title={<div style={{ fontSize: 12 }}>Logout</div>}
                  className={classes.tooltip}
                  onClick={this.handleDialogOpen}
                >
                  <ExitToAppIcon
                    style={{
                      width: 30,
                      height: 30,
                      color: "#181818",
                      marginRight: 10,
                    }}
                  />
                </Tooltip>
              </div>
              <CustomDialogBox
                question="Are you sure you want to logout?"
                description="Click logout button to logout from the system"
                buttonLabel="Logout"
                open={this.state.dialogOpen}
                handleClose={this.handleDialogClose}
                handleDelete={this.handleLogout}
              />
            </Toolbar>
          </AppBar>
        </div>

        <div className={classes.sectionMobile}>
          <AppBar position="fixed" className={classes.mobileToolbar}>
            <Toolbar>
              <div style={{ width: "100%", display: "flex" }}>
                {this.state.bottomMenu.map((menu, index) => (
                  <BottomMenu
                    menu={menu}
                    key={index}
                    index={index}
                    handleActiveMenu={this.handleActiveMenu}
                    handleToggleDrawer={this.handleToggleDrawer}
                  />
                ))}
              </div>
            </Toolbar>
          </AppBar>
          {this.state.mobileOpen === true && (
            <MobileDrawer
              userName={this.state.userName}
              role={this.props.role}
              mobileOpen={this.state.mobileOpen}
              handleToggleDrawer={this.handleToggleDrawer}
              userLogout={this.props.userLogout}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userId: state.UserReducer.userId,
    userToken: state.UserReducer.userToken,
    userRefreshToken: state.UserReducer.userRefreshToken,
    isUser: state.UserReducer.isUser,
    role: state.UserReducer.role,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    userLogout: () => {
      dispatch(userLogout());
    },
    getUserRefreshToken: (refreshToken, role) => {
      dispatch(getUserRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(UserBar)));
